import { jsx as e } from "react/jsx-runtime";
import { useStripe as t, PaymentElement as i } from "../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
function o() {
  return t() ? /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(
    i,
    {
      options: {
        fields: {
          billingDetails: {
            name: "never",
            email: "never"
          }
        }
      }
    }
  ) }) : null;
}
export {
  o as StripeBancontactDetails
};
